module.exports = __webpack_public_path__ + "img/contact-fredrikandersson.75e153da.png";